/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { useState, useCallback, useContext, useEffect } from "react";
import { useFormik } from "formik";
import { handleRecorderByICCard, handleConfirmRecorder } from "api/timeRecorder";
import useToastNotification from "hooks/useToastNotification";
import RecorderByICCardDomain from "domain/timeRecorder/recorderByICCardDomain";
import ConfirmRecorderByICCardDomain from "domain/timeRecorder/confirmRecorderByICCardDomain";

import InfoStaffTimeRecorderDomain from "domain/timeRecorder/infoStaffTimeRecorderDomain";
import { CurrentTimeDomain } from "domain/master/attend/currentTime";
import { TimeRecorderContext } from "components/organismos/RecorderV2/RecorderV2";
import * as icCard from 'hooks/useICCard';
import useAudio from 'hooks/useAudio';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';
import { useDispatch } from 'react-redux';
import { uiAppBarActions } from 'modules/ui/appBar';
import { icCardActions } from 'modules/ui/icCard';

const LOCAL_STORAGE_SHOP_INFO_KEY_NAME = "win-board-localstorage-shop-info";

const { errorNotification, successNotification } = useToastNotification();
const AUTO_PAUSE_DETECT_CARD = true;

export const useICCardRecorderNotAll = (
  stampOrgCode: string,
  setStampOrgCode: any,
  stampOrgName: string,
  setStampOrgName: any,
  loginOrgCode: string,
  setLoginOrgCode: any,
  loginOrgName: string,
  setLoginOrgName: any,
  resultCurrentTime: CurrentTimeDomain,
  setOpenModal: any,
  setIsLoading: any,
  fetchHistoryData: any
) => {

  // redux
  const dispatch = useDispatch();

  const playAudioSuccess = useAudio('/audio/soundDetectSuccess.mp3').playAudio;
  
  const playAudioError = useAudio('/audio/soundDetectError.mp3').playAudio;

  const isConnectICCardUsb = useSelector((state:Store) => state.ui.icCard.isConnectICCardUsb);
  const deviceICCard = useSelector((state:Store) => state.ui.icCard.deviceICCard);
  const cardId = useSelector((state:Store) => state.ui.icCard.cardId);

  // get local storage
  const contextObject = useContext(TimeRecorderContext);  
  const {companyCode, shopCode, stampByBelongOrg} = contextObject;

  const [isConfirm, setIsConfirm] = useState(false);
  const [isConnectUsb, setIsConnectUsb] = useState(false);
  const [actionDetect, setActionDetect] = useState(false);

  //Use New UI Remote
  const [newUiRemote, setNewUiRemote] = useState<boolean>(false);
  const [isRemote, setIsRemote] = useState<boolean>(false);

  // ID
  const [inputBarcodeId, setInputBarcodeId] = useState("");
  const [barcodeId, setBarcodeId] = useState("");

  // Staff
  const [stampMode, setStampMode] = useState(4);
  const [staffName, setStaffName] = useState("");

  // type
  const [lastStampType, setLastStampType] = useState<any>();
  const [stampType, setStampType] = useState<any>();

  const [disabledICCard, setDisabledICCard] = useState<boolean>(false);
  
  const [businessList, setBusinessList] = useState<any>();
  const [businessName, setBusinessName] = useState("")
  
  const onSubmit = async (values: ConfirmRecorderByICCardDomain) => {
    setIsLoading(true);
    try {
      await handleRecorderByICCard(shopCode, companyCode, values.getRawData()).then(
        (response: InfoStaffTimeRecorderDomain) => {
          setIsConfirm(true);
          playAudioSuccess();
          const stampStaffData = response.stampStaffList[0];
          setLastStampType(stampStaffData.lastStampType);
          setBusinessCnt(stampStaffData.businessList.length);
          setBusinessList(stampStaffData.businessList);
          setBarcodeId(stampStaffData.barcodeId);
          setNewUiRemote(stampStaffData.useRemote);
          setIsRemote(stampStaffData.isRemote);
          setStaffName(stampStaffData.staffName)
          setIsLoading(false);
        }
      );
    } catch (error) {
      fetchHistoryData();
      playAudioError();
      setTimeout(() => {
        dispatch(icCardActions.setDisabledDetect(false));
        dispatch(icCardActions.setHardCardId(''));
      }, 3000);
      setIsLoading(false);
      if (error.response.data.message) {
        errorNotification(error.response.data.message);
        return;
      }
      if (error.response && error.response.data && error.response.data.errors) {
        const listErr = error.response.data.errors;
        let stringErr = "";
        listErr.map((element: any) => {
          stringErr += `${element.defaultMessage} \n`;
          return stringErr;
        });
        errorNotification(stringErr);
      } else {
        errorNotification("サーバー側でエラーが発生しました。");
        throw error;
      }
    }
  };

  const formik = useFormik({
    initialValues: ConfirmRecorderByICCardDomain.generateInitial(),
    onSubmit,
  });
  const handleSubmitICCard = useCallback((cardId: string) => {
    setIsLoading(true);
    setStampMode(4); 
    formik.setFieldValue("stampMode", stampMode);
    formik.setFieldValue("stampByBelongOrg", stampByBelongOrg);
    formik.setFieldValue("orgName", stampOrgName);
    formik.setFieldValue("orgCode", stampOrgCode);
    formik.setFieldValue("loginOrgName", loginOrgName);
    formik.setFieldValue("loginOrgCode", loginOrgCode);
    formik.setFieldValue("staffName", staffName);
    formik.setFieldValue("cardId", cardId);
    formik.setFieldValue("inputCardId", cardId);
    formik.setFieldValue("stampTime", String(resultCurrentTime.serverDateTime));
    formik.submitForm();
  }, [
    barcodeId,
    formik,
    loginOrgCode,
    loginOrgName,
    resultCurrentTime.serverDateTime,
    staffName,
    stampByBelongOrg,
    stampMode,
    stampOrgCode,
    stampOrgName,
  ]);

  const [,setStaffCode] = useState("");
  const [businessCnt, setBusinessCnt] = useState(0);
  //submit
  const handleRecorder = useCallback(
    (stampType: number, businessId?: string, businessName?: string, flagRemote?: boolean) => {
      if(flagRemote){
        formikConfirm.setFieldValue("isRemote", true);  
      }else{
        formikConfirm.setFieldValue("isRemote", isRemote);  
      }
      setBusinessName(businessName||"");
      setStampType(stampType);
      formikConfirm.setFieldValue("orgCode", stampOrgCode);
      formikConfirm.setFieldValue("orgName", stampOrgName);
      formikConfirm.setFieldValue("loginOrgName", loginOrgName);
      formikConfirm.setFieldValue("loginOrgCode", loginOrgCode);
      formikConfirm.setFieldValue("staffName", staffName);
      formikConfirm.setFieldValue("cardId", cardId);
      formik.setFieldValue("inputCardId", cardId);
      formikConfirm.setFieldValue(
        "stampTime",
        String(resultCurrentTime.serverDateTime)
      );
      formikConfirm.setFieldValue("stampType", stampType);
      formikConfirm.setFieldValue("businessId", businessId);
      formikConfirm.setFieldValue("stampMode", stampMode);
      
      formikConfirm.submitForm();
      setIsConnectUsb(true);
      // setCodeICCard('');
    },
    [
      barcodeId,
      inputBarcodeId,
      loginOrgCode,
      loginOrgName,
      resultCurrentTime.serverDateTime,
      staffName,
      stampMode,
      stampOrgCode,
      stampOrgName,
      cardId
    ]
  );

  const onSubmitConfirm = async (values: RecorderByICCardDomain) => {
    setIsLoading(true);
    handleConfirmRecorder(shopCode, companyCode, values.getRawData(), 0).then(
      (response: any) => {
        successNotification(
          response.stampResultInfo.replace("<h4>", "").replace("</h4>", "")
        );
        dispatch(icCardActions.setDisabledDetect(false));
        dispatch(icCardActions.setHardCardId(''));
        setIsConfirm(false);
        fetchHistoryData();
        formik.resetForm();
        formikConfirm.resetForm();
        setInputBarcodeId("");
        setOpenModal(false);
        setIsLoading(false);
      }
    ).catch((error: any) => {
      fetchHistoryData();
      dispatch(icCardActions.setDisabledDetect(false));
      dispatch(icCardActions.setHardCardId(''));
      setIsLoading(false);
      setIsConfirm(false);
      setOpenModal(false);
      if (error.response.status === 400) {
        if (error.response.data.errors && error.response.data.errors.length > 0) {
          errorNotification(
            error.response.data.errors.map((x: any) => x.defaultMessage)
          );
        } else if (error.response.data.defaultMessage) {
          errorNotification(error.response.data.defaultMessage);
        } else {
          errorNotification(error.response.data.message);
        }
      } else {
        errorNotification("サーバー側でエラーが発生しました。");
      }
    });
  };

  const formikConfirm = useFormik({
    initialValues: RecorderByICCardDomain.generateInitial(),
    onSubmit: (values) => {
      onSubmitConfirm(values);
    },
  });
  
  const detectCard = () => {
    try {
      if(!deviceICCard){
        icCard.connectDevice(dispatch);
      }
      setActionDetect(true);
      // icCard.detectCard(deviceICCard, dispatch);  
      // icCard.detectCard(setCodeICCard, setIsConnectUsb, dispatch);
    } catch (error) {
      errorNotification(error);
    }
  }
  
  useEffect(() => {
    if(deviceICCard && actionDetect && dispatch){
      icCard.detectCard(deviceICCard, dispatch, AUTO_PAUSE_DETECT_CARD);
    }
  }, [deviceICCard, actionDetect, dispatch])

  useEffect(() => {
    if(cardId){
      handleSubmitICCard(cardId);
    }
  }, [cardId])
  
  useEffect(() => {
    return () =>{
      dispatch(icCardActions.setDisabledDetect(false));
      dispatch(icCardActions.setHardCardId(''));
    }
  },[])
 

  // useEffect(() => {
  //   if(isConnectUsb && codeICCard){
  //     playAudio();
      
  //     handleSubmitICCard(codeICCard);
  //     setIsConnectUsb(false);
  //     setDisabledICCard(true);
  //   }
  // }, [isConnectUsb, codeICCard])

  return {
    formik,
    businessList,
    lastStampType,
    setIsConfirm,
    isConfirm,
    staffName,
    businessCnt,
    formikConfirm,
    handleRecorder,
    stampOrgCode,
    businessName,
    stampType,
    newUiRemote,
    isConnectUsb,
    setIsConnectUsb,
    detectCard,
    disabledICCard,
    isConnectICCardUsb
  };
};
export default useICCardRecorderNotAll;
